/* eslint-disable no-useless-escape */
import React from 'react';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import PopupLoader from 'components/common/PopupLoader';
import { addAlert } from 'store/actions/alert/alerts';
import {
  authGetRequest,
  authPostRequest,
  authPatchRequestWithParam,
} from 'helpers/apiRequests';
import { fromUpperCaseToUnderScore } from 'helpers/variablesNamesFit';

import ComponentUserRender from 'components/user/admin/users/ComponentUserRender';

const AddUsers = props => {
  const { goBackToMainScreen } = props;

  const dispatch = useDispatch();
  const [organizations, setOrganizations] = React.useState([]);
  const [userGroups, setUserGroups] = React.useState([]);

  const useString = () => {
    const language = useSelector(state => state.language);

    return language;
  };
  const [alertsSubtitles] = React.useState(useString().alerts);
  const [subtitles] = React.useState(useString().adminZone.user.addUser);
  const [subtitlesErrors] = React.useState(useString().errors);

  const [seeableLoader, setSeeableLoader] = React.useState(false);
  const [showErrors, setShowErrors] = React.useState(false);
  const [userPermissionNames] = React.useState(useString().userPermissionList);
  const [groupArray, setGroupArray] = React.useState([]);
  const [values, setValues] = React.useState({
    firstName: '',
    lastName: '',
    password: '',
    rePassword: '',
    username: '',
    phone: '',
    email: '',
    city: '',
    street: '',
    number: '',
    organization: '',
  });

  const handleApiRequest = () => {
    authGetRequest('organizations').then(result => {
      if (result.status === 200) setOrganizations(result.data);
      else {
        dispatch(
          addAlert({
            title: alertsSubtitles[result.data.code].title_,
            desc: alertsSubtitles[result.data.code].desc_,
            type: 'error',
          })
        );
      }
    });
    authGetRequest('permissionsList').then(result => {
      if (result.status === 200) setUserGroups(result.data);
      else {
        dispatch(
          addAlert({
            title: alertsSubtitles[result.data.code].title_,
            desc: alertsSubtitles[result.data.code].desc_,
            type: 'error',
          })
        );
      }
    });
  };

  React.useEffect(handleApiRequest, []);

  const handleChange = event => {
    const { target } = event;
    const { name, value } = target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  const validateAlphanumeric = (value, keyValue) => {
    if (!value.match(/^[0-9a-zA-Z]+$/)) {
      setValues({ ...values, [keyValue]: '' });
      return true;
    }
  };

  const validatePhone = value => {
    if (!value.match(/^(\+|00)?[1-9][0-9 \-\(\)\.]{7,32}$/)) {
      setValues({ ...values, phone: '' });
      return true;
    }
  };

  const validatePassword = value => {
    if (
      !value.match(
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,40}$/
      )
    ) {
      setValues({ ...values, password: '', rePassword: '' });
      return true;
    }
  };

  const onGroupChange = event => {
    const { value, checked } = event.target;
    if (checked) {
      setGroupArray([...groupArray, parseInt(value)]);
    } else {
      const index = groupArray.indexOf(parseInt(value));
      setGroupArray(groupArray.filter((_, i) => i !== index));
    }
  };

  const isDataValid = () => {
    let isValid = true;
    Object.keys(values).forEach(key => {
      if (values[key] === '') isValid = false;
    });
    if (values.password !== values.rePassword) {
      values.password = '';
      values.rePassword = '';
      isValid = false;
    }
    if (validateAlphanumeric(values.username, 'username')) isValid = false;
    if (validatePhone(values.phone)) isValid = false;
    if (validatePassword(values.password)) isValid = false;

    if (!values.city) isValid = false;
    if (!values.number) isValid = false;
    
    if (!groupArray.length) isValid = false;
    if (!isValid) setShowErrors(true);
    return isValid;
  };

  const getSelectedOrganizationName = () => {
    if (organizations.length && values.organization !== '')
      return organizations.find(x => x.uid === values.organization).uid;

    return 'none';
  };

  const isGroupChecked = id => {
    if (groupArray.length && id !== undefined) {
      return groupArray.indexOf(id) >= 0;
    }
    return false;
  };

  const add = async () => {
    if (!isDataValid()) return;
    setSeeableLoader(true);
    const data = { ...values };
    let permissionResult;
    data.address = {
      city: values.city,
      street: values.street,
      number: values.number,
    };

    delete data.city;
    delete data.street;
    delete data.number;
    delete data.rePassword;

    const groupData = { groups: groupArray };

    const parsedData = fromUpperCaseToUnderScore(data);

    const result = await authPostRequest('addUser', parsedData);

    if (result.status === 201) {
      if (result.data.uid) {
        permissionResult = await authPatchRequestWithParam(
          'permissions',
          result.data.uid,
          groupData
        );
      }
    }

    if (result.status === 201 && permissionResult.status === 200) {
      dispatch(
        addAlert({
          title: alertsSubtitles.addDataSuccess.title_,
          desc: alertsSubtitles.addDataSuccess.desc_,
          type: 'success',
        })
      );
      setSeeableLoader(false);
      goBackToMainScreen();
    } else
      dispatch(
        addAlert({
          title: alertsSubtitles[result.data.code].title_,
          desc: alertsSubtitles[result.data.code].desc_,
          type: 'error',
        })
      );
    setSeeableLoader(false);
  };
  return (
    <>
      {seeableLoader && <PopupLoader />}
      <ComponentUserRender
        add={add}
        values={values}
        handleChange={handleChange}
        onGroupChange={onGroupChange}
        getSelectedOrganizationName={getSelectedOrganizationName}
        isGroupChecked={isGroupChecked}
        showErrors={showErrors}
        organizations={organizations}
        userGroups={userGroups}
        groupArray={groupArray}
        goBackToMainScreen={goBackToMainScreen}
        subtitles={subtitles}
        subtitlesErrors={subtitlesErrors}
        userPermissionNames={userPermissionNames}
      />
    </>
  );
};
AddUsers.propTypes = {
  goBackToMainScreen: PropTypes.func.isRequired,
};

export default AddUsers;
